"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const splunk_bunyan_logger_1 = tslib_1.__importDefault(require("splunk-bunyan-logger"));
const Logger = tslib_1.__importStar(require("bunyan"));
class SplunkLogger {
}
SplunkLogger.setLogger = (splunkToken, splunkUrl) => {
    const config = {
        token: splunkToken,
        url: splunkUrl ? splunkUrl : "https://hec.vwcredit.com",
        port: 443,
    };
    const splunkStream = splunk_bunyan_logger_1.default.createStream(config);
    const splunkLogger = Logger.createLogger({
        name: "VCI-Splunk-Logger",
        streams: [splunkStream],
    });
    return splunkLogger;
};
exports.default = SplunkLogger;
;
//# sourceMappingURL=SplunkLogger.js.map